import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {ReturnReason} from "@/models";

export class ReturnReasonService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetAll(query: any) {
        return this.baseApiFactory.getData<ReturnReason[]>('/api/ReturnReason', query);
    }

    GetByParent(parentId: number) {
        return this.baseApiFactory.getData<ReturnReason[]>(`/api/ReturnReason/parent/${parentId}`);
    }

    Insert(values: any) {
        return this.baseApiFactory.post<boolean>('/api/ReturnReason', values);
    }

    Update(value: any) {
        return this.baseApiFactory.put<boolean>('/api/ReturnReason', value);
    }

    Delete(id: string) {
        return this.baseApiFactory.delete<boolean>('/api/ReturnReason/' + id);
    }
}

lazyRegister.service('ReturnReasonService', ReturnReasonService);
